import React, {useContext, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import Chip from "components/Chip";
import {IncidentsContext} from "contexts/IncidentsContext";
import {selectIncidentsLoading} from "store/selectors";
import {ASSIGNMENT_MAP, STATUS_MAP} from "models/options";
import css from "./FilterChips.module.scss";

const FilterChips = () => {
  const {t} = useTranslation();
  const isLoading = useSelector(selectIncidentsLoading);

  const {handleMetricsCardSearch, filterSettings} =
    useContext(IncidentsContext);

  const FilterChip = (props) => (
    <Chip
      className={css.filterChip}
      disabled={isLoading}
      rightIcon="x"
      small={false}
      style={{opacity: isLoading ? 0.5 : 1}}
      {...props}
    />
  );

  const chips = useMemo(() => {
    const chipsArray = [{component: null}];

    const removeFilter = (filter) => {
      const newStatusFilter = filterSettings.statusFilter.filter(
        (type) => type !== filter
      );
      const newAssigneeFilter = filterSettings.assigneeFilter.filter(
        (type) => type !== filter
      );
      const searchVal = {
        ...filterSettings,
        statusFilter: newStatusFilter,
        assigneeFilter: newAssigneeFilter
      };
      handleMetricsCardSearch(searchVal);
    };

    const allFilters = [
      ...filterSettings.statusFilter,
      ...filterSettings.assigneeFilter
    ];

    // setting: string
    const filterChips = allFilters.map((setting) => {
      const statusChipText = STATUS_MAP[setting]?.name
        ? `${t("incidents.filters.statusPrefix")}: ${STATUS_MAP[setting]?.name}`
        : null;
      const assignmentChipText = ASSIGNMENT_MAP[setting]?.name
        ? `${t("incidents.filters.assignmentPrefix")}: ${
            ASSIGNMENT_MAP[setting]?.name
          }`
        : null;
      return {
        component: (
          <FilterChip key={setting} onClick={() => removeFilter(setting)}>
            {statusChipText}
            {assignmentChipText}
          </FilterChip>
        )
      };
    });
    chipsArray.push(...filterChips);

    return chipsArray;
    // t not necessary in dependency array.
  }, [filterSettings, handleMetricsCardSearch]);

  return (
    <div className={css.filterChips} data-testid={"FilterChips-Container"}>
      {chips.map((chip) => chip.component)}
    </div>
  );
};

export default FilterChips;
